export default {
  addRecipe: "إضافة وصفة",
  menuItem: "عنصر القائمة",
  selectMenuItem: "اختر عنصر القائمة...",
  ingredient: "المكوّن",
  quantity: "الكمية",
  unit: "الوحدة",
  action: "الإجراء",
  egOnion: "مثال: بصل",
  selectUnit: "اختر الوحدة",
  saveRecipe: "حفظ الوصفة",
  pleaseSelectMenuItem: "يرجى اختيار عنصر من القائمة!",
  pleaseEnterIngredient: "يرجى إدخال مكوّن واحد على الأقل."
};